
export enum TagCategory {
    hardwareItem = 'hardware-item',
    product = 'product',
    procedure = 'procedure',
    fixture = 'fixture',
    asset = 'asset'
}